<style scoped lang="scss">
    @import "../../styles/var";

    .scroll {
        overflow-y: auto;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .sbar {
        width: 4px;
        height: 100px;
        background-color: $mainColor;
        border-radius: 2px;
    }
</style>
<template>
    <div class="relative">
        <div class="scroll" :style="style" @scroll.passive="scroll" ref="scroll">
            <slot></slot>
        </div>
        <div v-if="showBar" class="sbar absolute r0 t0" :style="barStyle"></div>
    </div>
</template>

<script>
  import {isEmpty} from "../../lib/utils";

  export default {
    name: "v-scroll",
    props: {
      showScrollBar: {
        type: Boolean,
        default: true,
      },
      height: {
        type: Number,
        default: 0
      },
      data: [Object, Array]
    },
    data() {
      return {
        option: {}
      }
    },
    computed: {
      showBar() {
        return !isEmpty(this.data) && this.showScrollBar;
      },
      style() {
        return {
          'height': this.height ? `${this.height}px` : 'auto'
        };
      },
      barStyle() {
        const {clientHeight, scrollHeight, scrollTop} = this.option;
        if (clientHeight === scrollHeight) return {
          display: 'none'
        };
        return {
          top: `${scrollTop / (scrollHeight) * 100}%`,
          height: `${clientHeight / scrollHeight * 100}%`
        }
      }
    },
    mounted() {
    },
    watch: {
      data: {
        handler() {
          this.init()
        },
        deep: true
      }
    },
    methods: {
      init() {
        this.$nextTick(() => {
          const el = this.$refs.scroll;
          const {clientHeight, scrollHeight, scrollTop} = el;
          this.option = {clientHeight, scrollHeight, scrollTop};
        })
      },
      scroll(e) {
        const el = this.$refs.scroll;
        if (el) {
          const {clientHeight, scrollHeight, scrollTop} = el;
          this.option = {clientHeight, scrollHeight, scrollTop};
          this.$emit('scroll', {clientHeight, scrollHeight, scrollTop});
          if (clientHeight + scrollTop >= scrollHeight) {
            this.$emit('scrollToEnd');
          }
        }
      },
      scrollToEnd() {
        const el = this.$refs.scroll;
        if (el) {
          el.scrollTop = el.scrollHeight - el.clientHeight;
        }
      }
    },
  }
</script>
